<template>
  <div id="app" @blur="blurred" @focus="focused">
    <!--This is just for get revert-->
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
export default {
  beforeCreate() {
    window.addEventListener("beforeunload", this.onBeforeUnload);
  },
  methods: {
    onBeforeUnload(e) {
      if (!this.confirmLeave()) {
        e.preventDefault();
        e.returnValue = "";
      }
    },
	blurred() {
      // console.log("blurred before: ", this.$store.state.isCurrentWindow);
      this.$store.state.isCurrentWindow = false;
      // console.log("blurred after: ", this.$store.state.isCurrentWindow);
	},
	focused() {
      // console.log("focued before: ", this.$store.state.isCurrentWindow);
      this.$store.state.isCurrentWindow = true;
      // console.log("focued after: ", this.$store.state.isCurrentWindow);
    },
    confirmLeave() {
      return window.confirm(
        "Do you really want to leave? you have unsaved changes!"
      );
    },
  },
};
</script>

<style>
/*body {
  background: #101010;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #fff;
  background: #101010;
}
.card,
.bg-dark {
  background: #1b1b1b;
  border-radius: 12px;
	color: #e8e8e8;
}
.nav-tabs,
.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  border-bottom: 0px solid;
  border-color: #000;
}
.nav-link.active {
  color: #ffb229 !important;
  background-color: #000 !important;
  border-radius: 12px 12px 0 0;
  border-color: #000;
} -->
.nav-tabs .nav-link:focus,
.nav-tabs .nav-link:hover {
  border-bottom: 0px solid;
  border-color: #000;
  border-radius: 12px 12px 0 0;
}
a {
  color: #ffb229;
}
.text-primary {
  color: #ffb229;
}
.btn-primary {
  color: #000;
  background: #ffb229;
  border: #f57f17;
}
.btn-primary:hover {
  color: #000;
  background: #f57f17;
  border: #ffb229;
}
a:hover {
  color: #f57f17;
}
hr {
  border-top: 1px solid #272727;
}
label {
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 2px;
}
.btn {
  border-radius: 25px;
} 
input,
select {
  background: #000000 !important;
  color: #fff !important;
}*/
[data-letters]:before {
  content: attr(data-letters);
  display: inline-block;
  font-size: 2.5em;
  width: 80px;
  height: 80px;
  line-height: 2.1em;
  text-align: center;
  border-radius: 50%;
  background: plum;
  vertical-align: middle;
  color: white;
}
@media (max-width: 992px) {
  [data-letters]:before {
    font-size: 2em;
  }
}
.make-screen-view {
  display: none !important;
  grid-area: span 12 / span 24 !important;
}
.make-video-view {
  display: block !important;
}
.position-center {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
}
*::-webkit-scrollbar {
  width: 5px;
	height: 5px;
}
*::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
*::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: #636363;
  outline: 1px solid #636363;
}
*::-webkit-scrollbar:horizontal {
	border-radius: 5px;
	background-color: #636363;
	outline: 1px solid #636363;
}
#ATT {
  text-align: center;
  width: 32px;
  height: 18px;
  float: right;
  position: absolute;
  top: 10px;
  right: 0px;
  box-shadow: 1px 0 4px #000;
  padding: 2px 5px;
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
  font-size: 10px;
}
#SPK {
  text-align: center;
  width: 32px;
  height: 18px;
  float: right;
  position: absolute;
  top: 10px;
  right: 0px;
  box-shadow: 1px 0 4px #000;
  padding: 2px 5px;
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
  font-size: 10px;
}
#HST {
  text-align: center;
  width: 32px;
  height: 18px;
  float: right;
  position: absolute;
  top: 10px;
  right: 0px;
  box-shadow: 1px 0 4px #000;
  padding: 2px 5px;
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
  font-size: 10px;
}
</style>